export default "__VITE_ASSET__HNJkxv3Z__"